import React, { useEffect } from 'react'
import downIcon from '../../../assets/images/prehome/down.svg'
import './options-redirect.scss';
import { graphql, useStaticQuery } from 'gatsby';

const  OptionsRedirect = () => {

    let show = false;
    let selectLabel = ''
    let selectList = ''
    let selectActivator = ''

    useEffect(() => {
        initSelectClick()
    }, [])

    const initSelectClick = () => {
        
        selectList = document.getElementById('select-list-options')
        selectActivator = document.getElementById('select-active-option')
        selectLabel = document.getElementById('select-active-option-label')     
        
        if (selectList) {                  
            selectList.addEventListener('click', handleSelectClick)
            selectList.addEventListener('mouseover', handleMouseOver)
            selectList.addEventListener('mouseout', handleMouseOut)
            selectLabel.addEventListener('mouseover', handleMouseOverLabel)
            selectLabel.addEventListener('mouseout', handleMouseOutLabel)
            selectActivator.addEventListener('click', handleShowListSelect)           
        }
    }

    const handleMouseOverLabel = () => {
        selectLabel.style.color = '#05386b'
    }
    const handleMouseOutLabel = () => {
        selectLabel.style.color = '#222'
    }
    const handleMouseOver = () => {      
        selectLabel.style.color = '#05386b'
    }
    const handleMouseOut = () => {       
        selectLabel.style.color = '#222'
    }
    const handleSelectClick = e => {         
        handleShow()      
        let childClicked = e.target        
        let value = childClicked.getAttribute('value')
        let textActiveSelect = document.getElementById('select-active-option-label')
        let optionText = childClicked.innerText
        let ctaButton = document.getElementById('select-cta')
        let listSelect = document.getElementById('select-list-options')

        ctaButton.setAttribute('href', value)
        textActiveSelect.innerText = optionText
        

    }

    const handleShowListSelect = () => {       
        let listSelect = document.getElementById('select-list-options')
        let icon = document.getElementById('arrow-icon')        
        show = !show;
        if(show){
            listSelect.classList.add('showing')
            icon.classList.add('icon-rotate-up');            
        }
        else{
            listSelect.classList.remove('showing')           
            icon.classList.remove('icon-rotate-up');
        }     
    }

    const handleShow = () => {
        let listSelect = document.getElementById('select-list-options')
        let icon = document.getElementById('arrow-icon')
        
        show = !show;
        if(show){
            listSelect.classList.add('showing')
            icon.classList.add('icon-rotate-up');            
        }
        else{
            listSelect.classList.remove('showing')           
            icon.classList.remove('icon-rotate-up');
        }        
    }

    const { contentfulEnlacesCanalesDigitales } = useStaticQuery( graphql`
      {
        contentfulEnlacesCanalesDigitales {
          enlacesOptions {
            enlace
            titulo
          }
        }
      }
    `);
    const { enlacesOptions } = contentfulEnlacesCanalesDigitales;
    return (
        <div className="m-options-redirect">
            <div className="select-active-option" value="/sucursar-virtual-personas" id='select-active-option'>
                <div className="select-active-option-label" id='select-active-option-label'>
                    Bamvirtual Personas
                </div>
                <div className="select-active-option-label-icon">
                    <img
                        id="arrow-icon"
                        className='select-active-option-img__down'
                        alt='Ícono de cerrar'
                        src={downIcon}                                        
                    />
                </div>
            </div>

            
            <ul className="select-list-options" id="select-list-options">
                {
                    enlacesOptions.map((item, index) => (
                        <li className="select-list-options-item" key={index} value={item.enlace}>{item.titulo}</li>
                    ))
                }                                        
            </ul>
            

            <a className="select-cta" id="select-cta" href={enlacesOptions[0].enlace}>
                ENTRAR
            </a>
        </div>
    )
}

export default OptionsRedirect